import {Participant} from './Participant';

export class Stamprubric {
  id: number;
  participantId: number;
  positionX: number;
  positionY: number;
  positionXf: number;
  positionYf: number;
  percentSize: number;
  rotation: number;
  contentPosition: number;
  pageStamp: number;
  stampOn: number;
  isOriginal: boolean;
  active: number;
  participantByParticipantId: Participant;
}
